import { FilterContextData } from 'contexts/FilterContext';
import { useContext } from 'react';

const useProfitPoolFiltersLoading = () => {
    const { allDimAndAttributeTypeList, timePeriodLoading, idForRestOfComponentLoading } =
        useContext(FilterContextData);

    return Boolean(
        allDimAndAttributeTypeList?.loading || timePeriodLoading || idForRestOfComponentLoading,
    );
};

export default useProfitPoolFiltersLoading;
